import { makeStyles } from '@material-ui/core';

export const usePurchaseProblenmsStyles = makeStyles(() => ({
  title: {
    fontSize: 16,
    marginTop: 16,
    color: '#464646',
    textAlign: (props) => (props.mobile ? 'center' : null),
  },
}));
